import React, {useEffect, useState} from 'react';
import {Button, Modal, Select} from "antd";
import axios, {get} from "axios";
import {API_PATH} from "../../components/const";
import {Checkbox, Col, Row} from 'antd';
import RoleModal from "./RoleModal";
import {toast} from "react-toastify";

const Roles = () => {
    const [permission, setPermission] = useState([])
    const [roles, setRoles] = useState([])
    const [rolesSel1, setRolesSel1] = useState([])
    const [rolesSel2, setRolesSel2] = useState([])
    const [selectRole, setSelectRole] = useState([])
    const [selectRoleValue, setSelectRoleValue] = useState("")
    const [isCountryModal, setIsCountryModal] = useState(false)
    const [removeModal, setRemoveModal] = useState(false)
    const [perList, setPerList] = useState([])

    const getMe = () => {
        axios.get(API_PATH + "user/me", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setPerList(res.data?.permission_actions)
            })
    }
    const getRoles = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/role/get_all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setRoles(res?.data)
            })
            .catch(err => {
                // toast.error("Ошибка")
            })
    }
    const getPermission = () => {
        axios.get(API_PATH + "permission/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setPermission(res?.data)
            })
            .catch(err => {
                // toast.error("Ошибка")
            })
    }
    const removeRole = () => {
        axios.delete(API_PATH + "company/" + localStorage.getItem('id') + "/role/"+selectRoleValue+"/delete" ,{headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setSelectRoleValue("")
                getRoles()
                setRemoveModal(false)
            })
    }
    const onChange1 = (checkedValues, rer) => {
        setRolesSel1(checkedValues)
        console.log(checkedValues)
        console.log(rer)
    };
    const onChange2 = (checkedValues) => {
        setRolesSel2(checkedValues)
        console.log(checkedValues)

    };
    const selectRolePer = (e) => {
        setSelectRoleValue(e)
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/role/" + e + "/get", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setSelectRole(res?.data?.permissions)
                setPermission(res?.data?.inactive_permissions)
            })
            .catch(err => {
                // toast.error("Ошибка")
            })
    }
    const sendRemove = () => {
        axios.put(API_PATH  + "company/"+localStorage.getItem('id') + "/role/" + selectRoleValue + "/update",
            {del_permission_ids: rolesSel2
            },
            {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                toast.success("Успешно удалено")
                selectRolePer(selectRoleValue)

            })
    }
    const sendAdd = () => {
        axios.put(API_PATH  + "company/"+localStorage.getItem('id') + "/role/" + selectRoleValue + "/update",
            {add_permission_ids: rolesSel1
            },
            {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                toast.success("Добавлено успешно")
                selectRolePer(selectRoleValue)

            })
    }
    useEffect(() => {
        getRoles()
        getMe()

        // getPermission()
    }, [])
    return (
        <div className="users">
            <div className="employees-header">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="left-head">
                        <h6 className="font-family-medium">Роли</h6>
                    </div>
                </div>

                <div className="inputs-box col-md-3 mt-3">
                    <label className="font-family-medium text-white">Выберите роль </label>
                    <div className="add-btn-modal">
                        <Select
                            placeholder="Поиск, чтобы выбрать"
                            optionFilterProp="children"
                            // className="w-100"
                            onSearch={getRoles}
                            style={{minWidth: "300px"}}
                            value={selectRoleValue}
                            defaultValue={selectRoleValue}
                            onChange={(e) => {
                                selectRolePer(e)
                                setRolesSel1([])
                                setRolesSel2([])
                            }}
                            filterOption={(input, option) => (option?.label ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={roles?.map((item) => {
                                return {
                                    value: item?.id,
                                    label:
                                    item?.name
                                };
                            })}
                        />
                        {perList?.filter(item => item === "add_role").length > 0
                            ?
                            <button className="add-btn-plus" style={{paddingLeft: "10px", paddingRight: "10px"}} onClick={() => setIsCountryModal(true)}>
                                <img src="/icon/plus.svg" alt="+"/>
                            </button>
                            :
                            ""}
                        {perList?.filter(item => item === "add_role").length > 0 && selectRoleValue > 0
                            ?
                            <button className="role-delete-btn ml-8"  onClick={() => setRemoveModal(true)}>
                                <img src="/icon/deletefill.svg" alt="+"/>
                            </button>
                            :
                            ""}

                    </div>
                </div>
            </div>

            <div className="permissions">
                <div className="permissions-left">
                    <div className="list">
                        <Checkbox.Group
                            style={{
                                width: '100%',
                            }}
                            // value={rolesSel1}
                            onChange={(e) => {
                                onChange1(e)
                                // console.log(permission)
                            }}
                        >
                        {
                            permission?.map((item, index) => (
                                <div className="d-block w-100">

                                        <Row>
                                            <Col    >
                                                <Checkbox value={item?.id}><span
                                                    className="text-white">{item?.name}</span></Checkbox>
                                            </Col>
                                        </Row>
                                </div>
                            ))
                        }
                        </Checkbox.Group>
                    </div>
                </div>
                <div className="permissions-left-control">
                    <button onClick={sendAdd} className="btn bg-transparent">
                        <img src="/icon/arrowleft.svg" alt=""/>
                    </button>
                </div>
                <div className="permissions-right-control">
                    <button onClick={sendRemove} className="btn bg-transparent">
                        <img src="/icon/arrowleft.svg" alt=""/>
                    </button>
                </div>
                <div className="permissions-right">
                    <div className="list">
                        <Checkbox.Group
                            style={{
                                width: '100%',
                            }}
                            // value={rolesSel2}
                            onChange={onChange2}
                        >
                        {
                            selectRole?.map((item, index) => (
                                <div  className="d-block w-100">

                                        <Row>
                                            <Col >
                                                <Checkbox value={item?.id}><span
                                                    className="text-white">{item?.name}</span></Checkbox>
                                            </Col>
                                        </Row>
                                </div>
                            ))
                        }
                        </Checkbox.Group>

                    </div>
                </div>
            </div>
            <RoleModal
                isLocModal={isCountryModal}
                setIsLocModal={setIsCountryModal}
                getRoles={getRoles}
            />
            <Modal title="Добавить"
                   open={removeModal}
                   onCancel={() => setRemoveModal(false)}
                   footer={[
                       <Button key="submit" type="primary" onClick={removeRole}>
                           Да
                       </Button>,
                       <Button key="submit" type="default" onClick={() => setRemoveModal(false)}>
                           Отменить
                       </Button>
                   ]}
            >
                <div className="cam-add-modal">
                    <div className="inputs-box">
                        <label className="font-family-medium">Вы уверены, что хотите удалить эту роль?</label>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Roles;